import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Token fallback (in case cookies are blocked cross-origin)
const TOKEN_KEY = "tbv_admin_token";

export function setStoredToken(token) {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
}

export function getStoredToken() {
    return localStorage.getItem(TOKEN_KEY);
}

api.interceptors.request.use((config) => {
    const t = getStoredToken();
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Ocurrió un error. Intente nuevamente.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
